<template>
  <div>
    <div class="manage-header">
      <el-button type="primary" size="small" @click="() => newCarousel()">
        + 新增图片</el-button
      >
    </div>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="icon" label="产品图片">
        <template slot-scope="scope">
          <img :src="scope.row.icon" min-width="70" height="70" />
        </template>
      </el-table-column>
      <el-table-column prop="url" label="跳转链接"> </el-table-column>
      <el-table-column prop="sort" label="排序"> </el-table-column>
      <!-- <el-table-column prop="status" label="角色状态">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{
              scope.row.status == 1 ? "启用" : "停用"
            }}</span>
          </template>
        </el-table-column> -->

      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)"
            >设置跳转链接</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.$index, scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="block">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="current"
        :page-sizes="[30, 50, 100, 200]"
        :page-size="30"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>

    <el-dialog
      title="轮播图信息"
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="handleClose"
    >
      <!-- 表单信息 -->
      <el-form :model="form" ref="form" label-width="100px">
        <el-form-item v-show="showflag" label="id" prop="id">
          <el-input v-model="form.id"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input v-model="form.sort" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="微信跳转地址" prop="url">
          <el-input
            v-model="form.url"
            placeholder="请输入微信跳转地址"
          ></el-input>
        </el-form-item>

        <el-form-item label="轮播图片" prop="icon">
          <el-upload
            class="avatar-uploader"
            action="#"
            :http-request="uploadBannerFils"
            :show-file-list="false"
            accept="image/*"
            :on-success="handleAvatarSuccess"
          >
            <img v-if="form.icon" :src="form.icon" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>

        <!-- <el-form-item label="轮播图片" prop="icon">
          <el-upload
            class="upload-demo"
            drag
            :http-request="uploadBannerFils"
            action="#"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :before-remove="beforeRemove"
            :on-exceed="handleExceed"
            :before-upload="beforeUpload"
            list-type="picture"
            multiple
            :limit="1"
            name="icon"
            :file-list="fileList"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
            <div class="el-upload__tip" slot="tip">
              只能上传jpg/png文件，且不超过500kb
            </div>
          </el-upload>
        </el-form-item> -->
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <!-- <el-button @click="clear">清 除</el-button> -->
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
    
    <script>
import {
  getCarouselImages,
  uploadFile,
  deletFile,
  saveBannerInfo,
  batchDelete
} from "@/api/carousel";
import qs from "qs";
export default {
  methods: {
    newCarousel() {
      this.action = "new";
      this.clear();
      this.fileList = [];
      this.dialogVisible = true;
    },

    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === 1) {
        return "warning-row";
      } else if (rowIndex === 3) {
        return "success-row";
      }
      return "";
    },

    beforeUpload(file) {
      // 截取上传文件的后缀名
      let fileType = file.name.substring(file.name.lastIndexOf(".") + 1);
      console.log(fileType);
      // 判断文件名的类型，允许多种就判断多个
      if (fileType !== "jpg" && fileType !== "jpeg" && fileType !== "png") {
        this.$message.warning(`请上传jpg、jpge或png的图片！`);
        this.fileList = [];
        return false;
      }
    },

    // 处理预览操作
    handlePreview(file) {
      console.log(this.fileList[0]);
      console.log(file, "handlePreview");
    },

    uploadBannerFils(file) {
      console.info(file.file);
      uploadFile(file.file).then((res) => {
        console.log(res.data, "uploadFile");
        if (res.data.code === 200) {
          const files = {
            name: file.file.name,
            url: res.data.data.filePath,
          };
          this.fileList.push(files);
          this.form.name = file.file.name;
          this.form.icon = res.data.data.filePath;
          // console.log(this.tableData,"tableData")
        }
      });
    },

    // 处理超出图片个数操作
    handleExceed(files, fileList) {
      this.$message.warning(
        `只能上传一个文件，若需要上传，请先删除之前上传的文件，再上传新的图片`
      );
    },

    // 移除之前的操作
    beforeRemove(file, fileList) {
      if (this.fileList.length === 0) {
        return;
      }
      console.log(fileList[0], "filelist");
      this.$confirm(`确定移除 ${file.name}？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          console.log("11111");
          this.deletBannerFile();
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "已取消修改",
          // });
        });

      return false;
    },

    deletBannerFile() {
      if (this.fileList.length === 0) {
        return;
      }
      deletFile(this.fileList[0].url).then(({ data }) => {
        if (data.code === 200) {
          this.fileList = [];
        }
      });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },

    submit() {
      let msg = "";
      if (this.action === "new") {
        msg = "确认新增轮播图?";
      } else {
        msg = "确认修改轮播图？";
      }
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.$confirm(msg, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              saveBannerInfo(qs.stringify(this.form)).then(({ data }) => {
                console.log(data, "savebanner");
                if (data.code === 200) {
                  this.getCarouselsTableinfo();
                  this.$message({
                    type: "success",
                    message: "处理成功!",
                  });
                  this.dialogVisible = false;
                  (this.form.icon = ""),
                    (this.form.sort = ""),
                    (this.form.product_id = ""),
                    (this.form.name = ""),
                    (this.form.type = ""),
                    (this.form.url = ""),
                    (this.form.id = "");
                }
              });
            })
            .catch(() => {});
        } else {
          return false;
        }
      });

      // this.dialogVisible = false;
    },
    handleClose() {
      if (this.action === "new") {
        this.deletBannerFile();
        this.clear();
      }
      this.fileList = [];
      this.dialogVisible = false;
    },
    uploadBannerFile() {
      console.log("111");
    },
    clear() {
      let this_ = this;
      (this.form.icon = ""),
        (this.form.sort = ""),
        (this.form.product_id = ""),
        (this.form.name = ""),
        (this.form.type = ""),
        (this.form.url = ""),
        (this.form.id = "");
      if (this.action === "edit") {
        this.$confirm("确认连轮播图片也一并清除么？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this_.deletBannerFile();
          })
          .catch(() => {
            return;
          });
      } else {
        this.deletBannerFile();
      }
    },
    cancel() {
      this.handleClose();
    },
    getCarouselsTableinfo() {
      var this_ = this;
      getCarouselImages().then((res) => {
        console.log(res.data, "getCarouselImages");
        if (res.data.code === 200) {
          this.$nextTick(() => {
            this.tableData = res.data.data.records;
            this.total = res.data.data.total;
          });
          // console.log(this.tableData,"tableData")
        }
      });
    },

    handlePerm() {},
    handleAvatarSuccess(){},
    handleDelete(index,row) {
      const params = { params: { id: row.id } };
      this.$confirm("确认删除该条轮播图信息？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            batchDelete(params).then(({ data }) => {
                if (data.code === 200) {
                  this.getCarouselsTableinfo();
                  
                  this.$message({
                    type: "success",
                    message: "删除成功!",
                  });
                }
              });
          })
          .catch(() => {
            return;
          });

    },
    handleEdit(index, row) {
      this.action = "edit";
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.form = JSON.parse(JSON.stringify(row));
      });
      if (this.fileList.length === 0) {
        const files = {
          name: row.icon,
          url: row.icon,
        };
        this.fileList.push(files);
      }

      // this.action = "edit";
    },
  },
  mounted() {
    this.getCarouselsTableinfo();
  },
  data() {
    return {
      tableData: [],
      showflag: false,
      form: {
        id: "",
        icon: "",
        sort: "",
        product_id: "",
        name: "",
        type: "",
        url: "",
      },
      fileList: [],
      action: "",
      dialogVisible: false,
      total: 0,
      size: "",
      current: 0,
      orders: "",
    };
  },
};
</script>
    
    <style lang='less' scoped >
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>